import { Plugin } from 'prosemirror-state';

import { AddMenuAudio, AudioRecorder as IconAudio } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import AllowForwardingDownloading from '../../../components/AllowForwardingDownloading';
import { addMenuItemType } from '../../../types/menus';
import { isAdvancedItemEnabled } from '../../../utils';
import { addAddMenuBlock, addAdvanceMenuItem } from '../../../utils/menus';
import { NODE_NAME } from '../consts';
import AudioNodeView from './NodeView';

function plugins({ createReactNodeView, t }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          audio(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: AudioNodeView,
            });
          },
        },
      },
    }),

    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.audio.title') as string,
            description: t('Lygo:Menu.audio.description') as string,
            icon: IconAudio,
            addMenuIcon: AddMenuAudio,
            addMenuItemType: addMenuItemType.media,
            attrs: { src: null },
            searchWords: ['audio', 'media', 'upload'],
          },
        ]);

        addAdvanceMenuItem(editorView, {
          name: NODE_NAME,
          title: t('Lygo:AdvancedMenu.audio.title'),
          components: [
            {
              name: 'allow_forwarding',
              component: (props) => (
                <AllowForwardingDownloading
                  {...props}
                  descKey={'Lygo:AdvancedMenu.audio.AllowForwarding.description'}
                  titleKey={'Lygo:AdvancedMenu.audio.AllowForwarding.title'}
                />
              ),
              isEnabled: isAdvancedItemEnabled,
            },
          ],
        });
        return {};
      },
    }),
  ];
}

export default plugins;
